module.exports = __webpack_public_path__ + "static/media/Sushi-Tei-Rewards-Logo.3a332d79.png";